/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   20121-01-11 10:27:50
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import React, { Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import { Icon } from '@shopify/polaris';
import { QuestionMarkMajor } from '@shopify/polaris-icons';

export const RenderTooltip = (props: Object) => {
  const id = _.uniqueId('tooltip');

  return (
    <Fragment>
      {/* Icon */}
      <span data-tip="dummy data" data-for={id}>
        {props.icon && (
          <span className={`tooltip ${props.disabled ? 'disabled' : ''}`}>
            <Icon source={QuestionMarkMajor} color="base" />
          </span>
        )}

        {props.children}
      </span>

      {/* Tooltip content */}
      <ReactTooltip
        id={id}
        className="extraTooltipClass Polaris-Tooltip-TooltipOverlay Polaris-Tooltip-TooltipOverlay--positionedAbove"
        delayHide={props.delayHide || 500}
        effect={props.effect || 'solid'}
        type="light"
        getContent={function () {
          return (
            <div
              className="Polaris-Tooltip-TooltipOverlay__Content"
              style={{ whiteSpace: 'normal' }}>
              {props.content}
            </div>
          );
        }}
        place={props.place || 'top'}
        disable={props.disabled}
      />
    </Fragment>
  );
};
